import Fuse from 'fuse.js';
import type { SelectableSuggestionItem } from './LocationFilter';

export const fuzzyFilter = ({
  items,
  searchText,
}: {
  items: SelectableSuggestionItem[];
  searchText: string;
}): { maxScore: number; suggestions: SelectableSuggestionItem[] } => {
  const fuse = new Fuse(items, {
    isCaseSensitive: false,
    shouldSort: true,
    includeScore: true,
    location: 0,
    threshold: 0.4,
    distance: 150,
    includeMatches: false, // We can set this to true to get indices that match the search text if we want to bold the matching substrings later
    keys: ['name'],
  });

  const results = fuse.search(searchText);

  return results.reduce<{
    maxScore: number;
    suggestions: SelectableSuggestionItem[];
  }>(
    (acc, item) => ({
      maxScore:
        item.score && item.score > acc.maxScore ? item.score : acc.maxScore,
      suggestions: acc.suggestions.concat(item.item),
    }),
    { maxScore: 0, suggestions: [] },
  );
};
